Enterprise = require 'models/enterprise'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'

module.exports = class EnterpriseList extends CollectionWithHelpers
  model: Enterprise

  initialize: ->
    @listenTo @, 'change:name', @sort
    return

  comparator: (enterprise) ->
    enterprise.get('name')



// WEBPACK FOOTER //
// ./app/scripts/models/collections/enterprise-list.coffee